import React, { useContext } from "react";
import { Route, Switch } from "polyrouter";
import { ProductCatalogDetails } from "./View/ProductCatalogDetails";
import { ProductCatalogList } from "./List/ProductCatalogList";
import { SelectedTenantContext } from "polyrouter/SelectedTenantProvider";

export const ProductCatalogRouter: React.FC = () => {
  const { tenant } = useContext(SelectedTenantContext);
  const tenantId = tenant?.id ?? "";
  return (
    <Switch nest>
      <Route path="/details/:id">
        <ProductCatalogDetails />
      </Route>
      <Route path="/">
        <ProductCatalogList tenantId={tenantId} />
      </Route>
    </Switch>
  );
};
